//import React from 'react'
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import DoneIcon from '@mui/icons-material/Done';
import { Link } from 'react-router-dom';
import PhotoGallery from "./Photogallery";

const Details = () => {
    return (
        <div>
            <div className='breadcrumb'><Link to="/">Home</Link> &nbsp;:&nbsp; <Link to="/listing">Listing</Link> &nbsp;:&nbsp; Details</div>
            <div className='ibodywrap'>
                <div className='row'>
                    <div className='col-md-3'>
                        <div className='bd-left-panel sticky-position'>
                            <div className='imgbox'><img src='images/general-store-img.jpg' className='fullimg' alt='General Store' /></div>
                            <div className="contant-person">
                                Contact Person: <span>Rahul Chaudhary</span>
                                <Link to="/">prajapatigstore@gmail.com</Link>
                            </div>
                            <div className='btn-box'>
                                <Link to="tel:+91 9315959130" className='contact-no'><CallRoundedIcon />+91 9315959130</Link>
                                <Link to="tel:+91 9315959130" className='whatsapp'><WhatsAppIcon />+91 9315959130</Link>
                                <Link to="tel:+91 9315959130" className='contact-no'><MarkEmailUnreadOutlinedIcon />Send Enquiry</Link>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-9'>
                        <div className='bd-right-panel'>
                            <div className='comp-details'>
                                <div className='logo-box'><img src='images/general-store-img.jpg' className='fullimg' alt='General Store' /></div>
                                <div className='title-box'><VerifiedIcon /> Prajapati General Store</div>
                                <div className='location-box'><FmdGoodOutlinedIcon /> Chautarwa Badgaon, PO - Badgaon, Bagaha - 1, West Champaran.</div>
                            </div>
                            <div className='clr'></div>
                            <div className='devider'></div>
                            <div className='service-box'>
                                <h2>Products:</h2>
                                <div className='services'><DoneIcon /> Medicine</div>
                                <div className='services'><DoneIcon /> Pooj Samagri</div>
                                <div className='services'><DoneIcon /> Cloths</div>
                                <div className='services'><DoneIcon /> Ladies Accessories</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> Medicine</div>
                                <div className='services'><DoneIcon /> Pooj Samagri</div>
                                <div className='services'><DoneIcon /> Cloths</div>
                                <div className='services'><DoneIcon /> Ladies Accessories</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> All General Products</div>
                            </div>
                            <div className='clr'></div>
                            <div className='devider'></div>
                            <div className='overview-box'>
                                <h2>Overview:</h2>
                                <div>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                                    <p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?</p>
                                    <ul>
                                        <li>Listing 1</li>
                                        <li>Listing 1</li>
                                        <li>Listing 1</li>
                                        <li>Listing 1</li>
                                    </ul>
                                </div>
                            </div>
                            <div className='clr'></div>
                            <div className='devider'></div>
                            <div>
                                <PhotoGallery />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Details
